// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.education-section {
    padding: 0 20px;
    font-size: .8rem;
    
  }
  
 .school, .education-section .degree {
    font-size: .7;
    font-weight: bold;
  }
  
    
  @media (max-width: 768px) {
    .education-section .school, .education-section .degree, .education-section .year {
      font-size: .7rem;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/styles/EducationSection.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;;EAElB;;CAED;IACG,aAAa;IACb,iBAAiB;EACnB;;;EAGA;IACE;MACE,gBAAgB;IAClB;EACF","sourcesContent":[".education-section {\r\n    padding: 0 20px;\r\n    font-size: .8rem;\r\n    \r\n  }\r\n  \r\n .school, .education-section .degree {\r\n    font-size: .7;\r\n    font-weight: bold;\r\n  }\r\n  \r\n    \r\n  @media (max-width: 768px) {\r\n    .education-section .school, .education-section .degree, .education-section .year {\r\n      font-size: .7rem;\r\n    }\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
